import { apiUrlV2 } from "../constants/apiUrl"
import rollbarLogger from "../utilities/rollbarLogger"

const initialState = {
  reminders: null,
  reminder: null,
}

const createRemindersSlice = (set, get) => ({
  ...initialState,
  fetchReminders: async () => {
    try {
      const response = await fetch(`${apiUrlV2}/reminders`, {
        headers: get().requestHeaders
      })
      const data = await response.json()
      set({ reminders: data.data })
    } catch (err) {
      get().logError('There was an error fetching reminders.', err)
    }
  },
  setReminder: (reminder) => set(() => ({ reminder: reminder })),
  resetRemindersSlice: () => {
    set(initialState)
  }
})

export default createRemindersSlice